import { useMutation } from "@tanstack/react-query"
import { api } from "../../../lib/api/client"
import type { CreateSystemTicketPayload } from "../types"

export function useCreateSystemTicket() {
  return useMutation({
    mutationFn: (data: CreateSystemTicketPayload) =>
      api.systemTickets.create(data as unknown as Record<string, unknown>),
  })
}
